import { axiosClient } from '@src/api/apiClient/axiosClient';

export type CompanyUserInviteRequest = {
  company: {
    name: string;
    name_kana: string;
    postal_code: string;
    prefecture_code: string;
    address: string;
  };
  company_user: {
    family_name: string;
    first_name: string;
    family_name_kana: string;
    first_name_kana: string;
    email: string;
    birthday: string;
  };
};
export const companyUserInviteRequestApiClient = {
  sendInviteRequest: async (params: CompanyUserInviteRequest) => {
    return await axiosClient.post('/company/company-users/request-invitation', params);
  },
};
